import React, { useEffect } from 'react'
import styles from './SettingPercentage.module.scss'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useState, useRef } from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'

const createNumberRange = (start) => {
	return Array.from({ length: 70 - start + 1 }, (_, index) => start + index)
}

const SettingPercentage = ({
	id,
	start,
	end,
	percentage,
	onPercentageChange,
	onRankChange,
	onDelete,
	isRankEditable = true,
}) => {
	const [isDropDownOpened, setIsDropDownOpened] = useState(false)
	const [selectedRank, setSelectedRank] = useState(end === 0 ? 'CUT' : end)
	const dropDownRef = useRef(null)

	useEffect(() => {
		setSelectedRank(end === 0 ? 'CUT' : end)
	}, [end])

	const toggleDropDown = () => {
		if (!isRankEditable) return
		setIsDropDownOpened((prev) => !prev)
	}
	const dropDownNumbers = createNumberRange(start > 3 ? start : 3)

	const handleItemSelect = (e, number) => {
		if (!isRankEditable) return
		e.stopPropagation()
		setSelectedRank(number)
		onRankChange(id, number)
		setIsDropDownOpened(false)
	}

	const handlePercentageInputChange = (e) => {
		const inputVal = e.target.value

		let processedValue

		if (inputVal !== '' && !/^\d+$/.test(inputVal)) {
			return
		}

		if (inputVal === '') {
			processedValue = null
		} else {
			processedValue = Number(inputVal)

			// 값 제한만 수행하고 blur는 호출하지 않음
			// 사용자가 입력하는 동안 포커스를 유지하도록 함
			if (processedValue > 100) {
				processedValue = 100
			} else if (processedValue < 1) {
				// 입력 중일 때는 1로 제한하지 않고, 사용자가 계속 입력할 수 있도록 함
				// 단, 빈 값이 아닌 경우에만 처리
				if (inputVal.length > 1) {
					processedValue = 1
				}
			}
		}

		onPercentageChange(id, processedValue)
	}

	useEffect(() => {
		if (!isRankEditable && isDropDownOpened) {
			setIsDropDownOpened(false)
		}
	}, [isRankEditable, isDropDownOpened])

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
				setIsDropDownOpened(false)
			}
		}

		if (isDropDownOpened) {
			// 드롭다운이 열렸을 때만 이벤트 리스너 추가
			document.addEventListener('mousedown', handleClickOutside)
		}

		// 클린업 함수: 컴포넌트 언마운트 또는 isDropDownOpened가 false가 될 때 리스너 제거
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [isDropDownOpened])

	const isRankCut = selectedRank === 'CUT' || selectedRank === 0

	return (
		<div className={styles.prizeSetting}>
			<div className={styles.settingsBox}>
				<div className={styles.settings_1}>
					<div className={styles.rankingDisplay}>
						{start}
						<div className={styles.between}>~</div>
					</div>
					<div
						className={`${styles.dropDownInput} ${isRankCut ? styles.dropDownInputCut : ''} ${!isRankEditable ? styles.dropDownInputDisabled : ''}`}
						ref={dropDownRef}
						onClick={toggleDropDown}
						role="button"
						aria-disabled={!isRankEditable}
						aria-haspopup="listbox"
						aria-expanded={isDropDownOpened}>
						<div
							className={`${styles.numberDisplay} ${isRankCut ? styles.numberDisplayCut : ''}`}>
							{selectedRank !== null && selectedRank !== ''
								? isRankCut
									? 'CUT'
									: selectedRank
								: ''}
						</div>
						<div className={styles.dropDownIconBox}>
							<ChevronDownIcon className={styles.dropDownArrow}></ChevronDownIcon>
						</div>
						{isDropDownOpened && (
							<ul
								className={`${styles.dropDownList} ${isDropDownOpened ? styles.dropDownListOpened : styles.dropDownListClosed}`}>
								<li
									key="cut"
									className={styles.dropDownListItem}
									onClick={(e) => handleItemSelect(e, 'CUT')}>
									CUT
								</li>
								{dropDownNumbers.map((number) => (
									<li
										key={number}
										className={styles.dropDownListItem}
										onClick={(e) => handleItemSelect(e, number)}>
										{number}
									</li>
								))}
							</ul>
						)}
					</div>
				</div>
				<div className={styles.inputWrapper}>
					<input
						type="text"
						onChange={handlePercentageInputChange}
						value={percentage}></input>
					<div className={styles.suffix}>%</div>
				</div>
			</div>
			<div className={styles.delete} onClick={() => onDelete(id)}>
				<XMarkIcon className={styles.xMark}></XMarkIcon>
			</div>
		</div>
	)
}

export default SettingPercentage
